import React from "react";
import PropTypes from "prop-types";
import { baseContainer } from "@base-provider";

export const hasPermission = (permissions) => {
  if (!permissions) return true;

  let hasPermission = false;
  if (Array.isArray(permissions)) {
    permissions.forEach((p) => {
      if (baseContainer.authenticationService.hasPermission(p)) hasPermission = true;
    });
  } else {
    hasPermission = baseContainer.authenticationService.hasPermission(permissions);
  }

  return hasPermission;
};

const SFAuthorized = ({ permissions, children }) => {
  var isPermitted = hasPermission(permissions);

  return isPermitted && <>{children}</>;
};

SFAuthorized.defaultProps = {
  permissions: null,
  children: "Insert content here",
};

SFAuthorized.propTypes = {
  permissions: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

export default SFAuthorized;
